// @flow
import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSPUserCommitCustomViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';

import { SPUserCommitCustomViewsContainer } from './SPUserCommitCustomViewsContainer';

export const SPUserCommitCustomViewsContainerWrapper = () => {
  const params = useParams();

  const dataFetchingArgs = useMemo(
    () => [
      { ...params },
      {
        refetchOnMountOrArgChange: true,
        skip: shouldSkipDataFetching(params),
      },
    ],
    [params]
  );

  const dataFetchingFunction = useCallback(useGetSPUserCommitCustomViewQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => {
        return <SPUserCommitCustomViewsContainer data={data} />;
      }}
    </DataFetcherContainer>
  );
};
